<h3>Liberação de CNAE Indesejado</h3>

<div fxLayout="row" fxLayoutAlign="left stretch">
  <!-- <div fxLayoutGap="20px" class="filter-container" *ngIf="hasWriteAccess"> -->
  <div fxLayoutGap="20px" class="filter-container">
    <div fxFlex="10" fxFlexAlign="center">
      <button class="fd-button" (click)="addReleaseOfUnwantedCnae()">
        <div class="d-flex  justify-content-center">
          <fa-icon icon='plus-circle' size="1x"></fa-icon> Incluir CNPJ
        </div>
      </button>
    </div>
  </div>
</div>

<form [formGroup]="formGroup">
  <div fxLayout="row" fxLayoutAlign="left stretch">
    <div fxLayoutGap="20px" class="filter-container">
      <div fxFlex="40">
        <fd-institution (institutionSelected)="changeSelectedInstitution($event)" [formGroup]="formGroup"
          [field]="fields.institution">
        </fd-institution>
      </div>

      <div fxFlex="40">
        <fd-service-contract [formGroup]="formGroup" [field]="fields.serviceContract"
          [institution]="selectedInstitution">
        </fd-service-contract>
      </div>

      <div fxFlex="30" fxFlexAlign="center">
        <fd-button [content]="'Buscar'" (trigger)="getAllReleaseOfUnwantedCnae(false)"></fd-button>
      </div>
    </div>
  </div>
</form>

<div class='list'>
  <app-list-release-of-unwanted-cnae
  [dataSource]="dataSource"
  [totalItens]="totalItens"
  (changePage)="changePage($event)"
  (editEvent)="editReleaseOfUnwantedCnae($event)"
  (searchEvent)="getAllReleaseOfUnwantedCnae(true)"
  (updateStatusEvent)="updateStatus($event)"
  [page]="pageNumberFilter"
  >
  </app-list-release-of-unwanted-cnae>
</div>
